import { AfterContentInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'sales-ui-opportunity-notes-edit',
  styleUrls: ['./opportunity-notes-edit.component.scss'],
  templateUrl: './opportunity-notes-edit.component.html',
  standalone: false,
})
export class OpportunityNotesEditComponent implements AfterContentInit {
  @Input() note: string;
  @Output() save: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @ViewChild('opportunityNotes', { static: true }) textarea: ElementRef;

  ngAfterContentInit(): void {
    this.textarea.nativeElement.focus();
  }

  handleSave(event: MouseEvent): void {
    event.stopPropagation();
    this.save.emit(this.note);
  }

  handleCancel(event: MouseEvent): void {
    event.stopPropagation();
    this.cancel.emit();
  }
}
